const acceptImageType = ['image/gif', 'image/png', 'image/jpeg'];
export const isAcceptableImageType = (val: string | undefined) => {
  console.log(val);
  return typeof val === 'string' && acceptImageType.includes(val);
};
